<template>
  <ld-modal-content class="json" title="JSON">
    <textarea v-model="jsonValue"></textarea>
    <template #footer>
      <div class="is-flex is-align-items-center is-justify-content-center">
        <button class="button is-primary" @click="$emit('save', jsonValue);$emit('close')">Save</button>
      </div>
    </template>
  </ld-modal-content>
</template>

<script>
import LdModalContent from "@/components/LdModalContent";
export default {
  name: "JsonText",
  components: {LdModalContent},
  props: ['existingData'],
  data() {
    return {
      jsonValue: JSON.stringify({ data: this.existingData.data }, null, 3)
    }
  }
}
</script>

<style scoped>
  textarea {
    width: 100%;
    height: 300px;
    padding: 15px;
  }
  .json {
    position: relative;
  }
</style>
